import { all, fork } from 'redux-saga/effects';

// import { appSaga } from './app/sagas';
import { optionsSaga } from './options/sagas';
import { signUpSagas } from './sign-up/sagas';
import { callbackRequestSagas } from './callback-request/sagas';
import { addressLookupSaga } from './address-lookup/sagas';
import { accountantLookupSaga } from './accountant-lookup/sagas';

export function* mainSaga() {
  yield all([
    fork(optionsSaga),
    fork(signUpSagas),
    fork(callbackRequestSagas),
    fork(addressLookupSaga),
    fork(accountantLookupSaga),
  ]);
}
